import React from "react";
import ProfileCard from "../../common/profileCard";
import RecruiterSidebar from "../../common/recruiterSidebar";
import RecruiterStatusGate from "../../common/recruiterStatusGate";
import SettingsLinks from "../settingsLinks/settingsLinks";
import ChangePasswordForm from "../../../common/ChangePasswordForm";

const RecruiterChangePassword = () => {
    return (
        <div className="content">
            <div className="container">
                <ProfileCard />
                <div className="row">
                    <RecruiterSidebar />
                    <div className="col-lg-9">
                        <RecruiterStatusGate>
                            <div className="mb-3">
                                <h5>Settings</h5>
                            </div>
                            <SettingsLinks />
                            <ChangePasswordForm />
                        </RecruiterStatusGate>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecruiterChangePassword;
